// This file was auto-generated by Fern from our API Definition.
export const TraceType = {
    Invocation: "invocation",
    Annotation: "annotation",
    Unknown: "unknown",
};
